
import _ from 'lodash';

const files = require.context(`.`, false, /\.js$/);
const uis = {};

files.keys().forEach(fileName => {
  if (fileName === `./index.js`) { return; }
  const uiName = _.camelCase(
    fileName.replace(/(\.\/|\.js)/g, ``)
  );
  uis[`ui/${uiName}`] = files(fileName).default;
});

export default uis;
